import React from 'react';

import { APP_ROUTES } from 'constants/routes';
import { useModalDispatch } from 'context/ModalContext';
import { MODAL_TYPES } from 'helpers/LayoutHelpers';
import { useConfig } from 'hooks/data/useConfig';
import { useUser } from 'hooks/data/useUser';
import { useNavigationStepCounter } from 'hooks/useNavigationStepCounter';
import { useScheduledNewsletterSubscribe } from 'hooks/useScheduledNewsletterSubscribe';

const NewsletterSubscribeModalManager = () => {

  // Hooks

  const { addModalToQueue, removeModalFromQueue } = useModalDispatch();
  const { stop, steps, isValidStep } = useNavigationStepCounter({ invalidUrls: [APP_ROUTES.CHECKOUT, APP_ROUTES.EMAG_GENIUS] });

  // Data Hooks

  const { data: user } = useUser({ isOptional: true });
  const { data: config } = useConfig();

  // Props

  const { newsletterInfo } = config || {};

  const {
    IS_SUBSCRIBE_DIALOG_SHOWN_IN_NAVIGATION,
    NUM_STEPS_AFTER_SUBSCRIBE_DIALOG_IS_SHOWN,
  } = newsletterInfo || {};

  const shouldTrackNavigation = IS_SUBSCRIBE_DIALOG_SHOWN_IN_NAVIGATION;

  const isEnabled = !!(
    shouldTrackNavigation
    && (user && !user?.subscribedToNewsletter)
    && NUM_STEPS_AFTER_SUBSCRIBE_DIALOG_IS_SHOWN
    && steps >= NUM_STEPS_AFTER_SUBSCRIBE_DIALOG_IS_SHOWN
    && isValidStep
  );

  const {
    isVisible: isModalVisible,
    markAsSeen
  } = useScheduledNewsletterSubscribe({ isEnabled });

  // Effects
  React.useEffect(() => {
    if (isModalVisible) {
      addModalToQueue({
        id: MODAL_TYPES.NEWSLETTER_SUBSCRIBE,
        props: {
          onOpen: () => {
            markAsSeen();
          }
        }
      });
      stop();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalVisible]);

  React.useEffect(() => {
    return () => {
      removeModalFromQueue(MODAL_TYPES.NEWSLETTER_SUBSCRIBE);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Render

  return null;
};

export default NewsletterSubscribeModalManager;
